import { get } from 'lib/request';

export const getActiveAdsByStore = async ({ storeSlug }) => {
  const {
    data: {
      storeAd: [storeAd = null],
    },
  } = await get(`/ads/store/${storeSlug}`);

  return storeAd;
};

getActiveAdsByStore.fallback = null;

export const getAds = async ({ type } = {}, opts) =>
  get(`/ads${type ? `?type=${type}` : ''}`, opts);

getAds.fallback = {
  data: {
    cardAd: [],
    sidebarAd: [],
    smallAd: [],
    storeFullAd: [],
    topAd: [],
    topbarHighlight: [],
  },
};

export const getNavbarAds = async (opts) => {
  const {
    data: { topbarHighlight },
  } = await getAds({ type: 'TOPBAR_HIGHLIGHT' }, opts);

  return topbarHighlight;
};

getNavbarAds.fallback = null;

export const getTopbarAd = async (opts) => {
  const {
    data: {
      topAd: [topbarAd = null],
    },
  } = await getAds({ type: 'TOP_AD' }, opts);

  return topbarAd;
};

getTopbarAd.fallback = null;

export const getSearchAd = async (opts) => {
  const {
    data: { sponsorAd = [] },
  } = await get(`/ads?type=SPONSOR_AD`, opts);

  return sponsorAd;
};
